import api from '../api';

import {
    fetchSendSmsStart,
    fetchSendSmsSuccess,
    fetchSendSmsFail,
} from '../reducers/endpoints/sendSms';
import { take, put, call } from 'redux-saga/effects';

export function* fetchSendSms(mss) {
    const url = `/mensagem/sms`;

    //const userToken = localStorage.getItem('token')

    const headerParams = {
        headers: {
            //    Authorization: `Bearer ${ userToken }`
        },
    };
    // console.log('>>>>>>>>>', mss);

    try {
        const { data: configWitLogin } = yield call([api, 'post'], url, mss.mss, headerParams);
        // console.log('***************', configWitLogin);
        yield put(fetchSendSmsSuccess(configWitLogin));
    } catch (error) {
        yield put(fetchSendSmsFail(error));
    }
}

export function* watchFetchSendSms() {
    while (true) {
        const { payload: mss } = yield take(fetchSendSmsStart);
        yield call(fetchSendSms, mss);
    }
}
